import React from 'react';

interface FupNorProps {
  width?: number;
  height?: number;
}

const FupNor: React.FC<FupNorProps> = ({ width = 80, height = 60 }) => (
  <svg width={width} height={height} viewBox="0 0 80 60" xmlns="http://www.w3.org/2000/svg">
    {/* OR-Körper */}
    <path d="M 10 10 Q 20 30 10 50 L 35 50 Q 62 30 35 10 Z" fill="#E8F4F8" stroke="#0D3559" strokeWidth="2" />
    
    {/* Negation-Kreis */}
    <circle cx="67" cy="30" r="5" fill="none" stroke="#0D3559" strokeWidth="2" />
    
    {/* Eingangs-Ankerpunkte */}
    <circle cx="5" cy="20" r="3" fill="#0D3559" />
    <circle cx="5" cy="40" r="3" fill="#0D3559" />
    
    {/* Ausgangs-Ankerpunkt */}
    <circle cx="75" cy="30" r="3" fill="#0D3559" />
    
    {/* Label */}
    <text x="28" y="35" fontSize="14" fill="#0D3559" textAnchor="middle" fontWeight="bold">≥1</text>
  </svg>
);

export default FupNor;
